import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import { useAuth } from "@/lib/auth";
import { Menu, X } from "lucide-react";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/how-it-works", label: "How it works" },
  { to: "/rates", label: "Live rates" },
  { to: "/accepted-cards", label: "Accepted cards" },
  { to: "/blog", label: "Blog" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);
  const nav = useNavigate();

  const linkCls =
    "text-[15px] font-bold text-[#5A5A7A] hover:text-[#1E1E3F] transition-colors whitespace-nowrap";

  return (
    <header
      className="w-full bg-[#FAF6EB]/95 backdrop-blur-sm sticky top-0 z-40"
      style={{ fontFamily: "'DM Sans', system-ui, sans-serif" }}
      data-testid="site-header"
    >
      <div className="max-w-[1240px] mx-auto px-6 lg:px-8 py-4 flex items-center justify-between gap-6">
        {/* Logo */}
        <Link
          to="/"
          data-testid="nav-logo"
          className="inline-flex items-center flex-shrink-0"
          onClick={() => setOpen(false)}
        >
          <img
            src="/logos/nexon-logo.webp"
            alt="GC Nexon"
            className="h-16 lg:h-20 w-auto object-contain"
          />
        </Link>

        {/* Desktop nav */}
        <nav className="hidden lg:flex items-center gap-8">
          {NAV.map((n) => (
            <Link key={n.to} to={n.to} className={linkCls} data-testid={`nav-${n.label.replace(/\s+/g, "-").toLowerCase()}`}>
              {n.label}
            </Link>
          ))}
          {user ? (
            <>
              <Link to="/dashboard" className={linkCls} data-testid="nav-dashboard">Dashboard</Link>
              <button
                onClick={() => { logout(); nav("/"); }}
                className={linkCls}
                data-testid="nav-logout"
                style={{ background: "none", border: "none", cursor: "pointer", padding: 0 }}
              >
                Sign out
              </button>
            </>
          ) : (
            <Link to="/signin" className={linkCls} data-testid="nav-signin">Sign in</Link>
          )}
        </nav>

        {/* CTA button (desktop) */}
        <Link
          to="/submit"
          data-testid="nav-cta-sell"
          className="hidden lg:inline-flex items-center px-5 py-2.5 rounded-full bg-[#636AC3] text-white text-sm font-bold shadow-md hover:shadow-lg hover:opacity-95 transition"
        >
          Sell gift card
        </Link>

        {/* Mobile toggle */}
        <button
          onClick={() => setOpen((o) => !o)}
          data-testid="nav-mobile-toggle"
          aria-label="Toggle menu"
          className="lg:hidden inline-flex items-center justify-center w-11 h-11 rounded-lg bg-[#1E1E3F] text-white flex-shrink-0"
        >
          {open ? <X size={20} /> : <Menu size={22} />}
        </button>
      </div>

      {/* Mobile drawer */}
      {open && (
        <div className="lg:hidden border-t border-slate-200 bg-white" data-testid="nav-mobile-drawer">
          <div className="max-w-[1240px] mx-auto px-6 py-4 flex flex-col gap-1">
            {NAV.map((n) => (
              <Link
                key={n.to}
                to={n.to}
                onClick={() => setOpen(false)}
                data-testid={`nav-mobile-${n.label.replace(/\s+/g, "-").toLowerCase()}`}
                className="px-3 py-3 rounded-lg text-[15px] font-bold text-[#1E1E3F] hover:bg-slate-50"
              >
                {n.label}
              </Link>
            ))}
            {user ? (
              <>
                <Link to="/dashboard" onClick={() => setOpen(false)} className="px-3 py-3 rounded-lg text-[15px] font-bold text-[#1E1E3F] hover:bg-slate-50">Dashboard</Link>
                <button
                  onClick={() => { logout(); setOpen(false); nav("/"); }}
                  className="px-3 py-3 rounded-lg text-[15px] font-bold text-[#1E1E3F] hover:bg-slate-50 text-left"
                >
                  Sign out
                </button>
              </>
            ) : (
              <Link to="/signin" onClick={() => setOpen(false)} className="px-3 py-3 rounded-lg text-[15px] font-bold text-[#1E1E3F] hover:bg-slate-50">Sign in</Link>
            )}
            <Link
              to="/submit"
              onClick={() => setOpen(false)}
              className="mt-2 inline-flex items-center justify-center px-5 py-3 rounded-full bg-[#636AC3] text-white text-sm font-bold shadow"
            >
              Sell gift card
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
